import { subscribe, getState } from '../state/store.js';
import { formatDateForDisplayValue, getDateSortValue } from '../utils/dates.js';
import { CAKE_SVG, SKULL_SVG, CANDLE_SVG, QUILL_SVG, LEVEL_UP_SVG } from '../utils/event-icons.js';

const activityList = document.getElementById('activityList');

const isDeadStatus = (status) => String(status || '').trim().toLowerCase() === 'dead';

const escapeHTML = (value = '') =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

const buildEvents = ({ characters, sessions, neverForgetEvents, levelUpEvents }) => {
  const events = [];

  (sessions || []).forEach((session) => {
    if (!session.session_date_played) return;
    events.push({
      icon: QUILL_SVG,
      title: session.session_number ? `Session ${session.session_number} Played` : 'Session Played',
      detail: session.notes || session.characters_present || '',
      date: session.session_date_played
    });
  });

  (neverForgetEvents || []).forEach((evt) => {
    if (!evt.event_date) return;
    events.push({
      icon: CANDLE_SVG,
      title: evt.event_name || 'Never Forget',
      detail: evt.description || '',
      date: evt.event_date
    });
  });

  (levelUpEvents || []).forEach((evt) => {
    if (!evt.event_date) return;
    events.push({
      icon: LEVEL_UP_SVG,
      title: `${evt.character_name || 'Unnamed'} reached level ${evt.to_level}`,
      detail: evt.from_level ? `Up from level ${evt.from_level}` : '',
      date: evt.event_date
    });
  });

  characters.forEach((character) => {
    const name = character.name || 'Unnamed';
    if (isDeadStatus(character.status) && character.deathday) {
      events.push({
        icon: SKULL_SVG,
        title: `${name} died`,
        detail: character.cause_of_death || '',
        date: character.deathday
      });
    }
    if (character.first_adventure) {
      events.push({
        icon: CAKE_SVG,
        title: `${name} began adventuring`,
        detail: '',
        date: character.first_adventure
      });
    }
  });

  return events.sort((a, b) => getDateSortValue(b.date) - getDateSortValue(a.date));
};

const renderRow = (event) => `<div class="activity-row">
  <span class="activity-icon">${event.icon}</span>
  <div class="activity-body">
    <p class="activity-title">${escapeHTML(event.title)}</p>
    ${event.detail ? `<p class="activity-detail">${escapeHTML(event.detail)}</p>` : ''}
  </div>
  <span class="activity-date">${escapeHTML(formatDateForDisplayValue(event.date))}</span>
</div>`;

const renderActivity = () => {
  if (!activityList) return;
  const events = buildEvents(getState());
  activityList.innerHTML = events.length
    ? events.map(renderRow).join('')
    : '<p class="placeholder">No activity logged yet.</p>';
};

export const initActivity = () => {
  subscribe(renderActivity);
  renderActivity();
};
